module.exports = __webpack_public_path__ + "static/media/payroll.a2ae648e.svg";